import React from 'react';
import './Button.css';

/**
 * Button
 * @param {string} variant  - 'primary' | 'outline' | 'ghost' | 'danger'
 * @param {string} size     - 'sm' | 'md' (default)
 */
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      className={`btn btn--${variant} btn--${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
